
import { Modal } from "react-bootstrap";
import { togglePlanSection } from "../../../../../../actions/show_modal_Action";
import { useDispatch } from "react-redux";
import { baseUrl } from "../../../../../../utils";

const UpgradeCard = ({ show, openMod }) => {

  const dispatch = useDispatch();
  
  return (
    <Modal
      size="lg"
      dialogClassName=" modal-dialog-centered modal-overflow personalizePopupModal dynamic-popup"
      show={show}
      onHide={openMod}
      centered
    >

      <Modal.Header className="justify-content-end personalize_wt" closeButton>
      </Modal.Header>


      <Modal.Body>
        <div className="row">
          <div className="col-lg-12">
            <div className="upgredeMain text-center">
              <div className="Errorimage pb-3" >
                <img src={baseUrl(`error/auto-moderation-error.png`)} className="img-fluid" width={500} height={300}  />
              </div>
              <div className="permissionMsg mt-4 px-4">
                <h4 className="ErrorMsg">Auto-Moderation</h4>
                <p className="msgSec">
                  Experience effortless content moderation. Use filters to make your
                  content private, public or delete visuals on the basis of handle,
                  hashtag, keyword, and tags.
                </p>
              </div>
              <div className="buttonUpgred mb-sm-5 mb-3">
                <a
                  href="javascript:;"
                  id="addonFeaturesScroll"
                  onClick={(e) => dispatch(togglePlanSection(true))}
                  className="commanBtn btn btn-primary px-5 d-inline-block"
                >
                  Upgrade Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpgradeCard;